export default "dist/b89838f0c6cbea873fe7aa46edcdcec7.woff";